import React from "react";
import OrderContextMenu from "../OrderContextMenu/OrderContextMenu";
import { CoverWizardModalPayload } from "../OrderContextMenu/CoverWizardModal/CoverWizardModal";
import OrderDto from "../../../store/actions/dtos/OrderDto";

interface ActionsCellProps {
  row: any;
  cloneOrderButton: boolean;
  coverWizardModalPayloadState: [
    CoverWizardModalPayload | null,
    React.Dispatch<React.SetStateAction<CoverWizardModalPayload | null>>,
  ];
  editAttachmentsModalPayloadState: [
    OrderDto | null,
    React.Dispatch<React.SetStateAction<OrderDto | null>>,
  ];
  onReloadOrders: () => void;
}

export function ActionsCell({
  row,
  cloneOrderButton,
  coverWizardModalPayloadState,
  editAttachmentsModalPayloadState,
  onReloadOrders,
}: ActionsCellProps) {
  const hideEditAttachments = !(row?.allowUpdates ?? true);
  const hideContextMenu = !cloneOrderButton && hideEditAttachments;
  if (hideContextMenu) return null;
  return (
    <OrderContextMenu
      hideEditAttachments={hideEditAttachments}
      cloneOrderButton={cloneOrderButton}
      coverWizardModalPayloadState={coverWizardModalPayloadState}
      editAttachmentsModalPayloadState={editAttachmentsModalPayloadState}
      order={row}
      reloadOrders={onReloadOrders}
    />
  );
}
